@if (multiDuctInformation()) {
  <section class="duct-section">
    @if (pointConnectedTo()) {
      <div class="connected-to-row">
        <gc-text [variant]="'bodyBold'">{{
          'pointInfo.connectedTo' | translate
        }}</gc-text>
        <gc-text [variant]="'body'"> {{ pointConnectedTo() }}</gc-text>
      </div>
    }
    @if (formattedStatus(); as status) {
      <div class="information-row">
        <gc-text [variant]="'bodyBold'">Status:</gc-text>
        <gc-text [variant]="'body'">{{ status }}</gc-text>
      </div>
    }
    @if (ductInformation()) {
      <div class="information-row">
        <gc-text [variant]="'bodyBold'">{{
          'pointInfo.duct' | translate
        }}</gc-text>
        <div class="color-container">
          <gc-text [variant]="'body'">{{ ductInformation()?.number }}</gc-text>
          <gc-text [variant]="'body'">{{
            ductInformation()?.colorName
          }}</gc-text>
          <div
            class="circle"
            [style.background-color]="ductInformation()?.colorCode"
          ></div>
        </div>
      </div>
      <hr />
    }
  </section>
  <section class="multiduct-section">
    <div class="information-row">
      <gc-text [variant]="'bodyBold'">{{
        'pointInfo.multiDuct' | translate
      }}</gc-text
      ><gc-text [variant]="'body'">
        {{ getMultiDuctName(multiDuctInformation()?.name ?? '') }}</gc-text
      >
    </div>
    <div class="information-row">
      <gc-text [variant]="'bodyBold'">{{
        'pointInfo.color' | translate
      }}</gc-text>
      <div class="color-container">
        <gc-text [variant]="'body'">{{
          multiDuctInformation()?.colorName
        }}</gc-text>
        <div
          class="duct"
          [style.background-color]="multiDuctInformation()?.colorCode"
        ></div>
      </div>
    </div>
    <div class="information-row">
      <gc-text [variant]="'bodyBold'">{{
        'pointInfo.label' | translate
      }}</gc-text
      ><gc-text [variant]="'body'">{{
        multiDuctInformation()?.ductName
      }}</gc-text>
    </div>
    <div class="information-row">
      <gc-text [variant]="'bodyBold'">{{
        'pointInfo.from' | translate
      }}</gc-text
      ><gc-text [variant]="'body'">{{
        multiDuctInformation()?.fromPointName
      }}</gc-text>
    </div>
  </section>
} @else {
  <div class="info-missing">
    <gc-text [variant]="'paragraph'" [textColor]="'secondary'">
      {{ 'pointInfo.informationMissing' | translate }}
    </gc-text>
  </div>
}
